import { UserCommentsService } from '@fair-play/infra';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RevokeCommentCommandPayload } from './revoke-comment.command-payload';

export class RevokeCommentCommandHandler {
  private readonly userCommentsService: UserCommentsService = inject(UserCommentsService);

  revoke(payload: RevokeCommentCommandPayload): Observable<void> {
    return this.userCommentsService.revokeComment({ commentId: payload.commentId });
  }
}
